// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Profile page components
import BaseLayout from "layouts/profile/components/BaseLayout";
import Header from "layouts/profile/components/Header";
import BasicInfo from "layouts/profile/components/BasicInfo";
import ChangePassword from "layouts/profile/components/ChangePassword";
import { useSelector } from "react-redux";

function Profile() {
  const { user } = useSelector((state) => state.authentication);
  return (
    <BaseLayout>
      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Header user={user} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <BasicInfo user={user} />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <ChangePassword />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </BaseLayout>
  );
}

export default Profile;
